<template>
  <div>
    <div class="area-header --uppercase">
      <a href="https://www.guidetofm.com/tactics/role-combinations/" target="_blank">
        {{ $t('tactics.responsibilities.positionalResponsibilities') }} &gt;
      </a>
    </div>

    <div 
      class="positional-responsibilities pitch-area-partnerships"
      v-for="(responsibilities, position) in analysis"
      :key="position">

      <div class="area-subheader data-table-row position-responsibility-table__row">
        <span class="--uppercase">
          <a :href="links[position]" target="_blank">{{ $t(`tactics.pitchAreas.${position}`) }} &gt;</a>
        </span>
        <span 
          :title="`${capitalise($t('tactics.responsibilities.performs.full'))} (${$t('tactics.responsibilities.atypically.full')})`"
          class="stat-table__column-header">
          {{ `${capitalise($t('tactics.responsibilities.performs.short'))} (${$t('tactics.responsibilities.atypically.short')})` }}
        </span>
        <span 
          :title="`${capitalise($t('tactics.responsibilities.contributes.full'))} (${$t('tactics.responsibilities.atypically.full')})`"
          class="stat-table__column-header">
          {{ `${capitalise($t('tactics.responsibilities.contributes.short'))} (${$t('tactics.responsibilities.atypically.short')})` }}
        </span>
      </div>

      <template v-for="(responsibility, key) in responsibilities">
        <div 
          class="data-table-row position-responsibility-table__row"
          :key="position + key">
          <span :class="{ 'responsibility--not-performed': !responsibility.performed }">
            {{ capitalise($t(`tactics.responsibilities.${key}`)) }}
          </span>
          <span class="responsibility__count">{{ responsibility.performers.count }} ({{ responsibility.performers.atypical || "-" }})</span>
          <span class="responsibility__count">{{ responsibility.contributors.count }} ({{ responsibility.contributors.atypical || "-" }})</span>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
export default {
  data: function() {
    return {
      links: {
        centralAttack: "https://www.guidetofm.com/tactics/central-attack/",
        centralMidfield: "https://www.guidetofm.com/tactics/central-midfield/",
        centralDefence: "https://www.guidetofm.com/tactics/central-defence/",
        leftFlank: "https://www.guidetofm.com/tactics/flanks/",
        rightFlank: "https://www.guidetofm.com/tactics/flanks/",
      }
    }
  },

  computed: {
    analysis() {
      return this.$store.getters.positionalResponsibilities;
    }
  },

  methods: {
    capitalise(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
}
</script>

<style scoped>
.positional-responsibilities {
  color: #fff;
  font-size: 14px;
  opacity: 0.87;
}

.position-responsibility-table__row {
  grid-template-columns: 1fr 40px 40px;
}

.position-responsibility-table__row > * {
  white-space: nowrap;
}

.responsibility__count {
  text-align: center;
}

.stat-table__column-header {
  font-size: x-small;
  text-align: center;
  overflow-x: clip;
}

.responsibility--not-performed {
  color: #C77037;
}
</style>
